import { potencyCodeMap } from '../constants/potency-code';
import { ITestClaimTransferPrescriptions } from '../types/interfaces/transfer-prescriptions';

export const getMedicationQuantityLabel = (medication: ITestClaimTransferPrescriptions) => {
    const potencyLabel = potencyCodeMap[medication.prescribable.potencyCode];

    if (!medication.otc) {
        const originalQuantity = medication.copayQuantity || 30;
        const originalDaysSupply = medication.copayDaysSupply || 30;

        const monthlyQuantity = Math.ceil((originalQuantity * 100 * (30 / originalDaysSupply)) / 100);

        if (!potencyLabel) {
            return monthlyQuantity;
        }

        return `${monthlyQuantity} ${monthlyQuantity > 1 ? potencyLabel.plural : potencyLabel.singular}`;
    } else {
        const originalQuantity = Number(medication.quantity) || 30;
        if (!potencyLabel) {
            return originalQuantity;
        }
        return `${originalQuantity} ${originalQuantity > 1 ? potencyLabel.plural : potencyLabel.singular}`;
    }
};
